"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createPaymentRequest = void 0;
const createPaymentRequest = async (supabase, obj) => {
    // get the order from the order_id
    const { data, error } = await supabase
        .from("payment_requests")
        .insert([obj])
        .select("*")
        .single();
    return { data, error };
};
exports.createPaymentRequest = createPaymentRequest;
